import moment from "moment"
import { createObjectPagePathname, getAsServerMediaUrl } from "@/services/pathname"
import 'moment/locale/fr'
moment.locale('fr')
import Link from "next/link"
import Image from "next/image"
import img from "@/assets/img/gallery/scolaire-1.jpg"
import { levels } from "@/services/school"

type SmallCardProps = {
    aroeven: Aroeven,
    schoolActivity: SchoolActivity
}

export default function SmallCard({
    aroeven,
    schoolActivity
}: SmallCardProps) {

    return (
        <>
            <Link href={createObjectPagePathname('SchoolActivity', schoolActivity)} className="vignette mini -type-1 scolaire">
                <div className="d-flex flex-row">
                    <div className="vignette__image">
                        <div className="cardImage ratio ratio-1:1">
                            <div className="cardImage__content">
                                {schoolActivity.media?.url &&
                                    <Image
                                        src={getAsServerMediaUrl(schoolActivity.media.url)}
                                        width={schoolActivity.media.metadata?.width ?? 100}
                                        height={schoolActivity.media.metadata?.height ?? 100}
                                        alt="image"
                                        sizes="100px"
                                        quality={50}
                                    />
                                }
                            </div>
                            <div className="cardImage__leftBadge">
                                <div className="tag">
                                    <h3 className="tag-title">{schoolActivity.levels.filter(level => level in levels).map(level => levels[level].name).join(', ')}</h3>
                                    <div className="tag-tail"></div>
                                </div>
                            </div>
                        </div>
                        {schoolActivity.duration &&
                            <div className="date">
                                <i className="fi fi-bs-pending"></i> {schoolActivity.duration}
                            </div>
                        }
                    </div>
                    <div className="vignette__content">
                        <span className="text-light-1 lh-10 text-10">
                            <i className="fi fi-rr-marker"></i> {schoolActivity.thematic.accomodation.address.city} ({schoolActivity.thematic.accomodation.address.postCode.slice(0, 2)})
                        </span>

                        <h4 className="vignette__title">{schoolActivity.name}</h4>

                        {/*<div className="type">Etres vivants et biodiversité</div>*/}
                    </div>
                </div>
            </Link>
        </>
    )
}